<template>
  <div style="width: 100%; margin-left: 1rem; margin-right: 1rem" class="row">
    <a-col class="col-12">
      <a-button type="primary" icon="plus" class="mb-3 mb-md-0" @click.prevent="addBank"> {{ $t('account.addBank') }} </a-button>
    </a-col>
    <template v-if="!loading">
      <div class="card col-12 col-xl-3 mr-5 mt-3" v-for="(item, index) in bank" :key="index">
        <div class="py-3 pl-3 d-flex justify-content-between">
          <div class="d-flex flex-column">
            <div class="d-flex" v-if="item.is_verified">
              <tick />
              <div class="text-bold"> Bank Verified </div>
            </div>
            <div class="d-flex" v-if="item.is_default">
              <a-icon type="check" />
              <div class="text-bold"> Default Bank </div>
            </div>
          </div>
        </div>
        <div class="pt-3 pl-3">
          <div class="d-flex justify-content-between">
            <div class="text-muted">
              {{ $t('account.bankInformation') }}
            </div>
          </div>
          <div>
            {{ item.bank_name }}
          </div>
        </div>
        <div class="pt-3 pl-3">
          <div class="text-muted">
            {{ $t('account.accountNo') }}
          </div>
          <div>
            {{ item.bank_accountnr }}
          </div>
        </div>
        <div class="pt-3 pl-3 pb-3">
          <div class="text-muted">
            {{ $t('account.accountHolder') }}
          </div>
          <div>
            {{ item.bank_accountname }}
          </div>
        </div>
        <div class="d-flex justify-content-between py-3 pl-3">
          <div v-if="!item.is_default">
            <a-button
              class="text-center"
              @click.prevent="setDefaultBank(item)"
            >
              Set as Default
            </a-button>
          </div>
          <div v-if="!item.is_default">
            <a-button
              class="text-center"
              @click.prevent="deleteBank(item)"
            >
              Delete Bank
            </a-button>
          </div>
        </div>
      </div>
    </template>
    <a-modal v-model="modalVisible" :title="modalTitle" :footer="null" @cancel="handleCancel">
      <FormBank
        :initialValue="initialValue"
        :bankList="bankList"
        :bank="bank"
        :loading="loading"
        :phoneNumber="profile.user_data.phone"
        @handle-modal="handleModal"
        :modalVisible="modalVisible"
        :isCancelModal="isCancelModal"
      />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Modal } from 'ant-design-vue'
import Tick from '@/components/Icons/Tick'
import FormBank from '@/components/Form/Bank/index'

export default {
  components: {
    tick: Tick,
    FormBank,
  },
  data: function () {
    return {
      modalVisible: false,
      initialValue: null,
      bankUser: [],
      modalTitle: null,
      isCancelModal: false,
    }
  },
  computed: {
    ...mapState('account', {
      bank: state => state.bank,
      profile: state => state.profile,
      loading: state => state.loading,
    }),
    ...mapState('data', {
      bankList: state => state.bankList,
    }),
  },
  methods: {
    addBank () {
      this.initialValue = null
      this.modalTitle = this.$t('account.addBank')
      this.modalVisible = true
    },
    edit (item) {
      this.modalVisible = true
      this.modalTitle = this.$t('account.editBank')
      // eslint-disable-next-line
      this.initialValue = item ? item : null
    },
    setDefaultBank (item) {
      this.$store.dispatch('account/SETDEFAULTBANK', item)
        .then(_ => {
          this.$notification.success({
            message: 'Change default Bank Account success',
          })
        })
        .catch(err => {
          this.$notification.error({
            message: 'Change default Bank Account failed',
            description: err.response?.data?.message || err.message,
          })
        })
    },
    deleteBank (item) {
      Modal.confirm({
        title: this.$t('account.modalDeleteBank'),
        onOk: () => {
          this.$store.dispatch('account/DELETEBANKACCOUNT', item)
            .then(_ => {
              this.$notification.success({
                message: this.$t('account.deleteBankSuccess'),
              })
            })
            .catch(err => {
              this.$notification.error({
                message: this.$t('account.deleteBankFailed'),
                description: err.response?.data?.message || err.message,
              })
            })
        },
        onCancel() {},
      })
    },
    handleCancel () {
      this.modalVisible = false
      this.isCancelModal = true
    },
    handleModal (value) {
      this.modalVisible = value
      this.isCancelModal = value
    },
  },
  created () {
    this.$store.dispatch('account/GETUSERBANK')
    this.$store.dispatch('data/GETBANKLIST')
    if (!this.profile?.user_data?.phone) {
      this.$store.dispatch('account/GETUSERPROFILE')
    }
  },
}
</script>
